// eslint-disable-next-line import/no-extraneous-dependencies
import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';

import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const pickListDetailBoarTtransform = createTransform(
  // transform state on its way to being serialized and persisted.
  inboundState => {
    // convert mySet to an Array.
    const newState = {
      loadingBinOptions: inboundState.loadingBinOptions,
      loadingBinId: inboundState.loadingBinId
    };
    return newState;
  },

  // transform state being rehydrated
  null,

  { whitelist: ['pickListDetailBoard'] }
);

const persistConfig = {
  // eslint-disable-next-line no-undef
  key: window.APP_KEY,
  storage,
  // whitelist
  whitelist: ['app', 'pickListDetailBoard'],
  transforms: [pickListDetailBoarTtransform]
};

export const history = createBrowserHistory();

export default (rootReducer, rootSaga) => {
  const middleware = [];
  const enhancers = [];

  // Connect the sagas to the redux store
  const sagaMiddleware = createSagaMiddleware();
  middleware.push(routerMiddleware(history));
  middleware.push(sagaMiddleware);
  if (process.env.NODE_ENV === `development`) {
    middleware.push(logger);
  }

  enhancers.push(applyMiddleware(...middleware));

  // Redux persist
  const persistedReducer = persistReducer(persistConfig, rootReducer(history));

  const store = createStore(persistedReducer, compose(...enhancers));
  const persistor = persistStore(store);

  // Kick off the root saga
  sagaMiddleware.run(rootSaga);

  return { store, persistor };
};
